"use strict";
import { getRequest, postRequest } from "@/services/RequestService";

export const getCallLog = async id => {
  const base_route = `calls/${id}`;
  const response = await getRequest(base_route);
  return response;
};

export const storeCallLog = async (id, request) => {
  const base_route = `calls/detail/store/${id}`;
  const response = await postRequest(base_route, request);
  return response;
};


